import { IconCheckmarkCircled } from '@wheely/ui-kit';
import { useCallback } from 'react';
import { FieldValues, useController, UseControllerProps } from 'react-hook-form';

import { Car } from '@/modules/car/model';
import { CarCell } from '@/shared/view/CarCell';
import { DataField } from '@/shared/view/DataField';

import s from './VehicleSelector.module.css';

interface IVehicleSelectorProps<
  TFieldValues extends FieldValues = FieldValues,
> extends UseControllerProps<TFieldValues> {
  vehicles: Car[];
}

const VehicleSelector = <TFieldValues extends FieldValues>({
  vehicles,
  name,
  rules,
  control,
  defaultValue,
  shouldUnregister,
}: IVehicleSelectorProps<TFieldValues>) => {
  const { field } = useController({ name, rules, control, defaultValue, shouldUnregister });
  const { ref, value, onChange, name: fieldName } = field;

  const handleChange = useCallback(
    (vehicle: Car) => {
      onChange(vehicle.id);
    },
    [onChange],
  );

  return (
    <div>
      {vehicles.map(vehicle => (
        <div key={vehicle.id} className={s.radio}>
          <label htmlFor={vehicle.id}>
            <input
              type="radio"
              ref={ref}
              id={vehicle.id}
              name={fieldName}
              value={value as string}
              onChange={() => handleChange(vehicle)}
            />
            <DataField title={<CarCell carId={vehicle.id} />}>
              {vehicle.id === value && (
                <div className={s.iconWrapper}>
                  <IconCheckmarkCircled width={24} height={24} className={s.icon} />
                </div>
              )}
            </DataField>
          </label>
        </div>
      ))}
    </div>
  );
};

export { VehicleSelector };
